import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { MessageService } from 'primeng/api';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../services/api.service';
import { init } from '../editorconfig';
import { Subscription } from 'rxjs';
import { FileUpload } from 'primeng/fileupload';

@Component({
  selector: 'app-idex-oc-transaction',
  standalone: false,
  templateUrl: './idex-oc-transaction.component.html',
  styleUrl: './idex-oc-transaction.component.scss'
})
export class IdexOcTransactionComponent implements OnInit, OnDestroy {
  proposalId: any;
  steps: any;
  activeIndex = 1;
  stapName: any;
  userGuide: string;
  routeList = [];
  MasterData: any;
  uploadedFiles: any[] = [];
  apiUrl = environment.APIUrl;
  commentForm: FormGroup;
  cols: any[] = [
    { field: 'name', header: 'Name', filterType: 'text' },
    { field: 'contact', header: 'Contact', filterType: 'text' },
    { field: 'email', header: 'Email', filterType: 'text' },
  ];
  route_cols: any[] = [
    { field: 'user.first_name', header: 'First Name', filterType: 'text' },
    { field: 'user.last_name', header: 'Last Name', filterType: 'text' },
    {
      field: 'proposal_step.name',
      header: 'Proposal Step Name',
      filterType: 'text',
    },
    { field: 'role.name', header: 'Role', filterType: 'text' },
  ];
  vendors: any;
  proposalName: any;
  winner = [];
  challenge_title: any;
  routeForm: FormGroup;
  visible = false;
  isEditorDisabled: boolean = false;
  init: EditorComponent['init'] = init;
  stagesList: any[] = [];
  roleList = [];
  userList = [];
  proposalData: any;
  isEditable: boolean = false;
  step_details: any;
  DocName: string;
  pdfdata: any;
  phaseId: any;
  displayDialog: boolean = false;
  schemeId: any;
  private subscriptions = new Subscription();
  userID: any;
  navigate_Step: any;
  unitList = [];
  userListCopy = [];
  filteredRouteList: any;
  evaluation = {
    challengeTitle: '',
    category: '',
    nodalAgency: '',
    date: null,
    evaluatorName: '',
    organisation: '',
    contact: '',
    email: '',
  };
  uploadedUrl: any;
  uploadedFileName: string = '';
  file: File;
  @ViewChild('fileUpload') fileUpload!: FileUpload;
  filteredUserList: any[];
  filteredSteps: any;
   unitListN: any;
  schemeName:string='Idex';
    tabList: any;
  activeTabIndex: any;
  activePhaseId: any;
  selectedPhaseId: any;
  currentPage: number;

  constructor(
    private api: ApiService,
    private route: ActivatedRoute,
    private messageService: MessageService,
    private fb: FormBuilder
  ) {
    const role = sessionStorage.getItem('user_role_id');
    this.userID = role;
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      const id = params['id'];
      const proposalName = params['name'];
      const phase = params['phase'];
      const scheme = params['scheme'];
      const step = params['step'];
      this.navigate_Step = step;
      this.schemeId = scheme;
      this.proposalId = id;
      this.proposalName = proposalName;
      this.phaseId = phase;
    });
       this.routeForm = this.fb.group({
  step: [null, Validators.required],
  role: [null, Validators.required],
  user: [null, Validators.required],
  // unit: [null, Validators.required],
  level: [null, Validators.required],
  approved: [false]
});
    this.routeFormNew = this.fb.group({
      user: [null],
    });
    this.getSteps();
    this.getTabs()

    this.commentForm = this.fb.group({
      comment: ['', Validators.required],
    });

    this.ongetmasterData();
    // this.onUserGuide('process')
    // this.getpermDetails()
  }
  ngAfterViewInit() {
    setTimeout(() => {
      // this.isEditorDisabled=true;
      if (this.isEditable) {
        this.isEditorDisabled = false;
        this.commentForm.enable();
      } else {
        this.isEditorDisabled = true;
        this.commentForm.disable();
      }
      // this.rebuildEditor()
    }, 3000);
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  getSteps() {
    const sub = this.api
      .getAPI(
        `/transaction/proposals/${this.proposalId}/steps/`
      )
      .subscribe((res) => {
        this.steps = res;
         this.filteredSteps = this.steps?.filter(s => !s.skipped) || [];
        const index =
          res.findIndex((item) => item.id == this.navigate_Step) || 0;
        if (index == -1) {
          this.stapName = res[0];
          this.activeIndexCode = res[0].code;
        } else {
          this.stapName = res[index];
          this.activeIndexCode = res[index].code;
        }
        this.onActiveIndexChange(this.stapName);
        // this.getUsers();
        // this.getpermDetails();
      });
    this.subscriptions.add(sub);
  }
  onStepChange(event: any) {
    const selectedStepId = event.value;
    const sub = this.api
      .getAPI(
        `/transaction/proposal-workflow/?proposal_step_id=${selectedStepId}`
      )
      .subscribe((res: any) => {
        this.proposalData = res;
      });
    this.subscriptions.add(sub);
  }
  reportList: any[] = [];
  getReportList() {
    this.reportList = [];
    this.api
      .getAPI(
        `/revenue/need/version-control/?proposal_step=${this.step_details.id}&proposal_step__proposal=${this.proposalId}`
      )
      .subscribe((res: any) => {
        this.reportList = res;
      });
  }
  documentList: any[] = [];
  getDocumentList() {
    this.documentList = [];
    const sub = this.api
      .getAPI(`/idex/dms/documents/${this.schemeId}/${this.proposalId}/`)
      .subscribe((res: any) => {
        this.documentList = this.prepareDocumentList(res);
      });
    this.subscriptions.add(sub);
  }
  prepareDocumentList(data: any): any[] {
    const docs: any[] = [];

    if (data.need_generation) {
      docs.push({
        name: 'Draft SOTR',
        url: data.need_generation.draft_sotr,
      });

      data.need_generation.need_files.forEach((file: any, index: number) => {
        docs.push({
          name: `Need File ${index + 1}`,
          url: file.file,
        });
      });
    }

    if (data.aip) {
      docs.push({
        name: 'AIP Document',
        url: data.aip.document,
      });
    }

    if (data.qa_agecy && data.qa_agecy.nomination_file.length > 0) {
      data.qa_agecy.nomination_file.forEach((file: any, index: number) => {
        docs.push({
          name: `QA Agency File ${index + 1}`,
          url: file.file,
        });
      });
    }

    if (data.aon_soc) {
      docs.push({
        name: 'AON',
        url: data.aon_soc.aon,
      });
      docs.push({
        name: 'SOC',
        url: data.aon_soc.soc,
      });
    }

    if (data.pre_rfp_meeting) {
      docs.push({
        name: 'Pre-RFP Meeting MoM',
        url: data.pre_rfp_meeting.mom,
      });
    }

    if (data.pre_bid_meeting) {
      docs.push({
        name: 'Pre-Bid Meeting MoM',
        url: data.pre_bid_meeting.mom,
      });
    }

    if (data.final_offer) {
      docs.push({
        name: 'Final Offer',
        url: data.final_offer.offer,
      });
    }

    return docs;
  }
  viewDocument(doc: any) {
    const url = environment.APIUrl + doc?.url;
    window.open(url, '_blank');
  }

  downloadDocument(doc: any) {
    const link = document.createElement('a');
    link.href = environment.APIUrl + doc?.url; // adjust to your key
    link.download = doc?.name || 'document';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  pdfconvert(htmlContent: string): void {
    const blob = new Blob([htmlContent], { type: 'text/html' });

    const url = window.URL.createObjectURL(blob);

    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = 'report.html'; // Or give dynamic filename
    anchor.click();

    // Cleanup
    window.URL.revokeObjectURL(url);
  }
  activeIndexCode: any = 'idex_001';
  onActiveIndexChange(event: any) {
    this.activeIndex = event.sequence;
    this.activeIndexCode = event.code;
    this.stapName = event;
    this.onUserGuide('process');
    this.getUsers();
    if (this.activeIndexCode === 'idex_005') {
      // this.isEditorDisabled = false;
      // this.commentForm.enable();
      // this.getVendorList();
      this.getHPSCVendors();
    }
    if (this.activeIndexCode == 'idex_006') {
      this.updateWinners();
    }
     this.getworkflowlogs()
    this.getpermDetails();
  }
  goToNextStep() {
    const currentIndex = this.steps.findIndex(
      (step) => step.code === this.activeIndexCode
    );
    const nextStep = this.steps
      .slice(currentIndex + 1)
      .find((step) => !step.skipped);

    if (nextStep) {
      // Delay to prevent double triggering
      setTimeout(() => {
        this.onActiveIndexChange(nextStep);
      }, 0);
    } else {
      console.warn('No next step found.');
    }
  }
  onUserGuide(event: string) {
    this.userGuide = event;

    if (this.userGuide == 'user') {
      this.getUsers();
    }
  }
  getUsers() {
    this.routeList = [];
    const sub = this.api
      .getAPI(
        `/transaction/proposal-workflow/?proposal_step_id=${this.stapName.id}`
      )
      .subscribe((res: any) => {
        this.getLogs();
        const usersMap = new Map();
        const sortedData = res.data.sort(
          (a: any, b: any) => a.sequence - b.sequence
        );

        for (const item of sortedData) {
          const userId = item.user?.id;
          const roleId = item.role?.id;
          if (userId && roleId) {
            const compositeKey = `${userId}_${roleId}`;
            if (!usersMap.has(compositeKey)) {
              usersMap.set(compositeKey, item);
            }
          }
        }

        this.routeList = Array.from(usersMap.values());
        this.filteredRouteList = this.routeList.filter(
          (member) => member.role.name !== 'Commenter'
        );
      });

    this.subscriptions.add(sub);
  }
  currentMatch: any = null;
  // Component methods
  getLogs() {
    this.api
      .getAPI(`/transaction/proposal-workflow-log/${this.stapName.id}/`)
      .subscribe((res: any) => {
        this.currentMatch = res.current_step;
        // this.cdr.detectChanges();
      });
  }

  // These methods should exist in your component
  get matchedIndex(): number {
    if (!this.currentMatch) return -1;
    return this.filteredRouteList.findIndex(
      (member) =>
        member.user?.id === this.currentMatch.user?.id &&
        member.role?.id === this.currentMatch.role?.id
    );
  }

  isInProgressPath(member: any, index: number): boolean {
    const matchIdx = this.matchedIndex;
    return matchIdx >= 0 && index <= matchIdx;
  }

  isConnectorActive(index: number): boolean {
    const matchIdx = this.matchedIndex;
    return matchIdx >= 0 && index < matchIdx;
  }

  // Check if connector should be active (before matched index)
  isConnectorInProgressPath(index: number): boolean {
    const matchIdx = this.matchedIndex;
    return matchIdx >= 0 && index < matchIdx;
  }

  // Only show connector if not last and next isn't Commenter
  shouldShowConnector(member: any, index: number, last: boolean): boolean {
    if (last || member.role.name === 'Commenter') return false;
    const nextItem = this.routeList[index + 1];
    return !(nextItem && nextItem.role.name === 'Commenter');
  }
 editeRoute() {
    this.visible = true;
    this.getRoleList();
    this.getUnit();
    this.getUserList();
    const sub = this.api
      .getAPI(
        `/transaction/proposals/${this.proposalId}/steps/?skipped=False&phase_id=${this.phaseId}`
      )
      .subscribe((res: any) => {
        this.stagesList = res;
        this.routeForm.get('step')?.setValue(this.stapName.id);
        this.getProposalWorkflow(this.stapName.id);
      });
    this.subscriptions.add(sub);
  }
  getProposalWorkflow(id: any) {
    this.proposalData = [];
    const sub = this.api
      .getAPI(`/transaction/proposal-workflow/?proposal_step_id=${id}`)
      .subscribe((res: any) => {
        this.proposalData = res.data;
      });
    this.subscriptions.add(sub);
  }

  onrouteFormSubmit() {
    if (this.routeForm.invalid) return;

    const formValue = this.routeForm.value;
    const selectedUser = this.userList.find(u => u.id === formValue.user);

    const payload = {
      status: 1,
      sequence: this.routeForm.get('level')?.value, // Convert level input to number
      proposal_step: formValue.step,
      user: formValue.user,
      role: formValue.role,
       unit: selectedUser ? selectedUser.unit?.id : null,
      is_final_approve: formValue.approved || false
    };
    const sub = this.api.postAPI(`/transaction/proposal-workflow/`, payload).subscribe({
      next: (res: any) => {
        // this.api.getAPI(`/transaction/proposal-workflow?proposal_step_id=${formValue.step}`).subscribe((res: any) => {
        //   this.proposalData = res;
        //   this.visible = false;

        // });
        this.visible = false;
        this.getUsers();
        this.routeForm.reset();
        // this.addProposalVisible = false;
      },
      error: (err) => {
        console.error('Update failed:', err);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: err?.error?.detail || 'Something went wrong while updating the mapping.',
        });
      }
    });
    this.subscriptions.add(sub);
  }
  getRoleList() {
    const sub = this.api.getAPI('/access/user-roles/').subscribe((res: any) => {
      let rolePriority;
      if (this.isIRA) {
        rolePriority = ['REC', 'APP'];
      } else {
        rolePriority = ['INT', 'REC', 'APP']; // desired order
      }
      const resp = res.data;

      // Filter and sort
      this.roleList = resp
        .filter((role) => rolePriority.includes(role.code))
        .sort(
          (a, b) => rolePriority.indexOf(a.code) - rolePriority.indexOf(b.code)
        );
    });
  }
  getUserList() {
    const sub = this.api.getAPI('/account/users/').subscribe((res: any) => {
      this.userList = res.data;
      this.userListCopy = [...this.userList];
    });
    this.subscriptions.add(sub);
  }
  getUnit() {
      let currentUnitId  = sessionStorage.getItem('unit_id');
    const sub = this.api.getAPI('/master/units/').subscribe((res: any) => {
      this.unitList = res.data;
      this.unitListN = res.data.filter((u: any) => u.id != Number(currentUnitId));
    })
    this.subscriptions.add(sub);
  }
  onRoleChange(event: any) {
    // this.roleID = event.value;
    this.tryFetchingSequence();
  }

  onUserChange(event: any) {
    // this.userID = event.value;
    this.tryFetchingSequence();
  }
  onUnitChange(event: any) {
    let unit_id = event.value;
    this.userList = this.userListCopy.filter(
      (user) => user.unit?.id == unit_id
    );
  }
  tryFetchingSequence() {
    const step = this.routeForm.get('step').value;
    const role = this.routeForm.get('role').value;
    const user = this.routeForm.get('user').value;
    if (step && role && user) {
      this.getSequence();
    }
  }

  getSequence() {
    const step = this.routeForm.get('step').value;
    const role = this.routeForm.get('role').value;
    const user = this.routeForm.get('user').value;
    const sub = this.api
      .getAPI(
        `/transaction/get-next-level/?proposal_step_id=${step}&role_id=${role}`
      )
      .subscribe((res: any) => {
        const sequenceValue = res.level ?? '';
        this.routeForm.get('level')?.patchValue(sequenceValue);
      });
    this.subscriptions.add(sub);
  }
  IRA: any;
  isIRA = false;
  IRAremarks: string;
  onIRA(event: any) {
    this.isIRA = true;
    this.IRA = event;
    if (this.step_details?.add_route_conf == true) {
      this.getRoleList();
      this.getUnit();
      this.getUserList();
      const sub = this.api
        .getAPI(
          `/transaction/proposals/${this.proposalId}/steps/?skipped=False&phase_id=${this.phaseId}`
        )
        .subscribe((res: any) => {
          this.stagesList = res;
          this.routeForm.get('step')?.setValue(this.stapName.id);
          this.getProposalWorkflow(this.stapName.id);
        });
      this.subscriptions.add(sub);
    }
    //console.log('ira', event)
  }
  submitIRA(ira_status: any) {
    if (this.IRA === 'Initiate') {
    }
    if (this.IRA === 'Approve') {
    }
    if (this.IRA === 'Recommend') {
    }
    if (this.step_details?.add_route_conf) {
      this.onrouteFormSubmit();
    }
    let role_id = sessionStorage.getItem('user_role_id');
    const payload = {
      proposal_step: this.stapName.id,
      role_id: role_id,
      is_approved: ira_status,
      remark: this.IRAremarks,
    };
    this.isIRA = false;
    this.IRAremarks = '';
    const sub = this.api
      .postAPI(`/transaction/proposal-ira-action/`, payload)
      .subscribe((res: any) => {
        this.isEditable = false;
        this.getProposalWorkflow(this.stapName.id);
        this.getpermDetails();
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: res.message || 'Proposal added successfully',
        });
      });
    this.subscriptions.add(sub);
  }

  getpermDetails() {
    const user_role_id = sessionStorage.getItem('user_role_id');
    const sub = this.api
      .getAPI(
        `/transaction/copy/proposals/${this.proposalId}/steps/?role_id=${user_role_id}`
      )
      .subscribe((res: any) => {
        let id = this.activeIndex - 1;
        this.step_details = res[id];
        const role = sessionStorage.getItem('user_role_id');
        this.isEditable =
          ((this.step_details.is_initiator ||
            this.step_details.is_approver ||
            this.step_details.is_recommender) &&
            this.step_details.can_edit) ||
          role == '6';
      });
    this.subscriptions.add(sub);
  }
  onUpload(event: any): void {
    const file = event.files?.[0];
    this.uploadedFileName = file.name;
    this.file = file;
  }
  getFileName(url: string): string {
    const fileName = url.split('/').pop() || 'Unknown File';
    return fileName.length > 35 ? fileName.substring(0, 30) + '...' : fileName;
  }

  generatePDF(event: any) {
    this.pdfdata = event;
    this.displayDialog = true;
  }

  isHTMLorText(input: any) {
    const doc = new DOMParser().parseFromString(input, 'text/html');
    // If the input contains HTML tags, return true (HTML), else false (Plain text)
    return Array.from(doc.body.childNodes).some((node) => node.nodeType === 1);
  }
  saveVersion() {
    const data = document.getElementById('printSection')?.innerHTML;

    if (!data) {
      console.error('Missing required data for saving version.');
      return;
    }
    const payload = {
      proposal_step: this.stapName.id,
      name: this.DocName,
      paragraph: data,
    };

    const sub = this.api.postAPI(this.pdfdata.url, payload).subscribe({
      next: (res) => {
        this.DocName = '';
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: res.message || 'Version saved successfully',
        });
      },
      error: (err) => {
        console.error('Error saving version:', err);
      },
    });
    this.subscriptions.add(sub);
  }
  entries: any[] = [];

  getVendorList() {
    const sub = this.api
      .getAPI(
        `/idex/vendor-identification/?proposal_step__proposal=${this.proposalId}&proposal_step=${this.stapName.id}`
      )
      .subscribe((res: any) => {
        this.vendors = res.data;
      });
    this.subscriptions.add(sub);
  }
  mapVendorsToEntries() {
    this.entries = this.vendors.map((vendor, index) => ({
      rank: '',
      vendor_id: vendor?.id,
      applicantName: vendor.name,
      entityType: '',
      companyName: '',
      relevance: 0,
      comprehensiveness: 0,
      innovation: 0,
      feasibility: 0,
      capability: 0,
      viability: 0,
      total: 0,
      percentage: 0,
      remarks: '',
      status: '',
      isEditMode: false,
    }));
  }
  resId: any;
  getHPSCVendors() {
    const sub = this.api
      .getAPI(
        `/idex/evaluation/?proposal_step__proposal=${this.proposalId}&proposal_step=${this.stapName.id}`
      )
      .subscribe((res: any) => {
        this.challenge_title = res.title;
        if (res.data[0]) {
          this.entries = res.data[0]?.evaluation;
          this.resId = res.data[0]?.id;
          this.uploadedUrl = res.data[0].file || '';
          this.commentForm.patchValue({
            comment: res.data[0].justification,
          });
          const evalData = res.data[0];

          // Map API fields to form model
          this.evaluation = {
            challengeTitle: res.title || '',
            evaluatorName: evalData.name_evaluator || '',
            category: res.category || '',
            organisation: evalData.org_evaluator || '',
            nodalAgency: res.nodal_agecy || '',
            contact: evalData.contact_detail || '',
            date: evalData.date_evaluator
              ? new Date(evalData.date_evaluator).toISOString().substring(0, 10)
              : '',
            email: evalData.email_id || '',
          };
        }
      });
    this.subscriptions.add(sub);
  }
  getRank() {
    const sorted = [...this.entries].sort((a, b) => b.total - a.total);
    sorted.forEach((entry, index) => {
      entry.rank = index + 1;
    });
  }
  validateScore(entry: any, field: keyof any) {
    if (entry[field] !== undefined && entry[field] !== null) {
      const value = Number(entry[field]);
      if (value < 0) entry[field] = 0;
      if (value > 10) entry[field] = 10;
    }
    this.calculateTotals(entry);
  }

  calculateTotals(entry: any) {
    const scores = [
      entry.relevance || 0,
      entry.comprehensiveness || 0,
      entry.innovation || 0,
      entry.feasibility || 0,
      entry.capability || 0,
      entry.viability || 0,
    ];
    entry.total = scores.reduce((a, b) => a + b, 0);
    entry.percentage = +((entry.total / 60) * 100).toFixed(2);
  }
  addRow() {
    this.entries.push({
      applicantName: '',
      entityType: '',
      companyName: '',
      relevance: 0,
      comprehensiveness: 0,
      innovation: 0,
      feasibility: 0,
      capability: 0,
      viability: 0,
      total: 0,
      remarks: '',
      rank: 0,
      status: '',
      isEditMode: true,
    });
  }
  saveRow(entry: any) {
    entry.isEditMode = false;
    let payload: {
      proposal_step?: number;
      evaluation: {
        vendor_id: any;
        rank: any;
        relevance: any;
        comprehensiveness: any;
        innovation: any;
        feasibility: any;
        capability: any;
        viability: any;
        total: any;
        remarks: any;
        vendor_status: any;
        id: number;
        percentage: number;
      }[];
    } = {
      evaluation: [
        {
          vendor_id: entry.vendor.id ? entry.vendor?.id : entry.vendor,
          rank: entry.rank.toString(),
          relevance: entry.relevance.toString(),
          comprehensiveness: entry.comprehensiveness.toString(),
          innovation: entry.innovation.toString(),
          feasibility: entry.feasibility.toString(),
          capability: entry.capability.toString(),
          viability: entry.viability.toString(),
          total: entry.total.toString(),
          remarks: entry.remarks,
          vendor_status: entry.status,
          id: entry.id,
          percentage: entry.percentage.toString(),
        },
      ],
    };
    if (!this.resId) {
      payload.proposal_step = this.stapName.id;
    }
    if (this.resId) {
      const sub = this.api
        .putAPI(`/idex/evaluation/${this.resId}/`, payload)
        .subscribe((res: any) => {
          if (res) {
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Vendor evaluation updated successfully',
            });
            // this.updateTotal(entry);
            this.getHPSCVendors();
          }
        });
      this.subscriptions.add(sub);
    } else {
      const sub = this.api
        .postAPI(`/idex/evaluation/`, payload)
        .subscribe((res: any) => {
          if (res) {
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Vendor evaluation updated successfully',
            });
            // this.updateTotal(entry);
            this.getHPSCVendors();
          }
        });
      this.subscriptions.add(sub);
    }
  }
  isFormInvalid(): boolean {
    // Check required fields (adjust as per your business rules)
    return (
      !this.evaluation.challengeTitle?.trim() ||
      !this.evaluation.evaluatorName?.trim() ||
      !this.evaluation.category?.trim() ||
      !this.evaluation.organisation?.trim() ||
      !this.evaluation.nodalAgency?.trim() ||
      !this.evaluation.contact?.trim() ||
      !this.evaluation.date ||
      !this.evaluation.email?.trim()
    );
  }

  onJustificationSubmit() {
    const formData = new FormData();
    formData.append('name_evaluator', this.evaluation.evaluatorName);
    formData.append('org_evaluator', this.evaluation.organisation);
    formData.append('contact_detail', this.evaluation.contact);
    formData.append('date_evaluator', this.evaluation.date);
    formData.append('email_id', this.evaluation.email);

    if (this.file) {
      formData.append('file', this.file);
    }
    const sub = this.api
      .putAPI(`/idex/evaluation/${this.resId}/`, formData)
      .subscribe({
        next: () => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: `Justification updated`,
          });
          this.uploadedUrl = null;
          this.uploadedFileName = '';
          this.getHPSCVendors();
        },
        error: () => {
          // this.messageService.add({
          //   severity: 'error',
          //   summary: 'Error',
          //   detail: `Failed to update justification`
          // });
        },
      });
    this.subscriptions.add(sub);
  }

  updateWinners(event: { page: number; search?: string } = { page: 1 }) {
    const sub = this.api
      .getAPI(
        `/idex/finalize/winner/?evaluation__proposal_step__proposal=${this.proposalId}&evaluation__proposal_step=${this.stapName.id}`
      )
      .subscribe((res: any) => {
        this.winner = res.data;
      });
    this.subscriptions.add(sub);
  }
  ongetmasterData() {
    const sub = this.api
      .getAPI(`/master/master-data/`)
      .subscribe((res: any) => {
        this.MasterData = res.data;
        this.MasterData = this.MasterData.map((item) => ({
          id: item?.id,
          name: item?.name,
          paragraph_1: item.paragraph_1,
          paragraph_2: item.paragraph_2,
          style: item.css_file_url,
          criteria_list: JSON.stringify(item.criteria_list, null, 2), // pretty JSON format
        }));
      });
    this.subscriptions.add(sub);
  }
  getStepNumber(step: any): number {
    let count = 0;
    for (let s of this.steps) {
      if (!s.skipped) {
        count++;
      }
      if (s === step) {
        return count;
      }
    }
    return 0; // fallback
  }
  canNavigateTo(step: any): boolean {
    if (step.code === this.activeIndexCode) {
      return true; // current step is clickable (but will do nothing)
    }

    return this.isStepCompleted(step); // only completed steps
  }

  onStepClick(step: any): void {
    if (step.code === this.activeIndexCode) {
      return; // do nothing if clicking on current step
    }

    if (this.isStepCompleted(step)) {
      // this.navigateToStep(step); // only backward allowed
      this.onActiveIndexChange(step);
    }
  }

  // isStepCompleted(step: any): boolean {
  //   const currentIndex = this.steps.findIndex(
  //     (s) => s.code === this.activeIndexCode
  //   );
  //   const stepIndex = this.steps.findIndex((s) => s.code === step.code);

  //   return stepIndex < currentIndex; // step is before current → completed
  // }

  navigateToStep(step: any): void {
    if (step.code === this.activeIndexCode) {
      return; // current step - do nothing
    }

    if (!this.isStepCompleted(step)) {
      return; // future step - prevent navigation
    }
    this.activeIndexCode = step.code;
  }
  clearUpload(fileUpload: any) {
    this.uploadedFileName = null;
    // this.uploadedUrl = null;
    fileUpload.clear();
  }
  allowOnlyNumbers(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight'];
    if (allowedKeys.includes(event.key)) return;

    const isNumber = /^[0-9]$/.test(event.key);
    if (!isNumber) {
      event.preventDefault();
    }
  }
  opennewRouteDialog: boolean = false;
  routeFormNew: FormGroup;
  addedUsers: any[] = [];
  editeRouteNew() {
    this.getUserList();
    this.opennewRouteDialog = true;
  }
  routeformModal() {
    console.log("Selected Users" , this.addedUsers)
  }
  selectedItem:any
  // Custom filter function
 onFilter(event: any) {
    const query = event.query.toLowerCase();

    // Filter the user list based on the input query
    this.filteredUserList = this.userList.filter(user =>
      user.first_name.toLowerCase().includes(query) ||
      user.last_name.toLowerCase().includes(query) ||
      user.loginname.toLowerCase().includes(query) ||
      user.email.toLowerCase().includes(query) ||
      user.hrcdf_designation.toLowerCase().includes(query)
    );
  }
  addSelectedUser() {
    const selectedUserId = this.routeFormNew.value.user;

    if (!selectedUserId) {
      alert('Please select a user first.');
      return;
    }

    const user = this.userList.find((u) => u.id === selectedUserId);

    if (user) {
      // Prevent duplicates
      const alreadyAdded = this.addedUsers.find((u) => u.id === user.id);
      if (alreadyAdded) {
        alert('User already added.');
        return;
      }

      this.addedUsers.push(user);
      this.routeFormNew.patchValue({ user: null }); // Optional: clear selection
    }
  }
  removeUser(userToRemove: any) {
  this.addedUsers = this.addedUsers.filter(user => user.id !== userToRemove.id);
}

 displayDialogN = false;
  shareType: string | null = null;
   selectedUserN: any;
  permissionType: string | null = null;
  selectedUnit: any;
  internalComment:string
  externalComment:string
    openDialog() {
    this.displayDialogN = true;
    this.getUserListN();
    this.getUnit()
    this.resetForm();
  }
  userListN:any
  getUserListN() {
  const unitId = Number(sessionStorage.getItem('unit_id'));

  const sub = this.api.getAPI('/account/users/').subscribe((res: any) => {
   let user = res.data;

    // Filter based on unit_id
    this.userListN = user.filter((user: any) => {
      return user.unit?.id === unitId;
    });
  });

  this.subscriptions.add(sub);
}

    resetForm() {
    this.shareType = null;
    this.selectedUserN = null;
    this.permissionType = null;
    this.selectedUnit = null;
  }
saveSelection() {
  const payload: any = {
    proposal_step: this.stapName.id, // Ensure this is defined in your component
    is_final_approve: false,
    route_type: this.shareType
  };

  if (this.shareType === 'internal') {
    payload.user = this.selectedUserN?.id;
    payload.unit = this.selectedUserN?.unit?.id || null; // if needed
    payload.flag = 1;
    payload.permission_type = this.permissionType;
    payload.remark = this.internalComment
  }

  if (this.shareType === 'external') {
    payload.unit = this.selectedUnit?.id;
     payload.remark = this.externalComment
  }

  console.log('Payload to submit:', payload);

  const sub = this.api.postAPI('/transaction/copy/proposal-workflow/', payload).subscribe({
    next: (res) => {
     this.getworkflowlogs()
      // Optionally close dialog or show success
      this.displayDialogN = false;
      this.routeConfigExpanded = true
    },
    error: (err) => {
      console.error('Error submitting workflow:', err);
      // Handle errors appropriately
    }
  });

  this.subscriptions.add(sub);
}
currentIndex = 0; // or bind it dynamically

get visibleSteps() {
  return this.filteredSteps?.slice(this.startIndex, this.startIndex + this.windowSize) || [];
}

navigate(direction: number) {
  const newIndex = this.currentIndex + direction;

  if (newIndex < 0 || newIndex >= this.filteredSteps.length) return;

  this.currentIndex = newIndex;
  this.activeIndexCode = this.filteredSteps[newIndex].code;
  this.onActiveIndexChange(this.filteredSteps[newIndex]);

  // Move the window forward if needed
  if (this.currentIndex >= this.startIndex + this.windowSize) {
    this.startIndex = this.currentIndex - this.windowSize + 1;
  }

  // Move the window backward if needed
  if (this.currentIndex < this.startIndex) {
    this.startIndex = this.currentIndex;
  }
}


isCurrent(step: any): boolean {
  return this.activeIndexCode === step.code;
}

isStepCompleted(step: any): boolean {
  if (!step) return false;

  const currentIndex = this.steps.findIndex(s => s.code === this.activeIndex);
  const stepIndex = this.steps.findIndex(s => s.code === step.code);

  // Step is completed only if it's before the current step AND approved
  return stepIndex < currentIndex && step.step_status === 'approved';
}
 expandedItems: { [key: number]: boolean } = {};
  animatedNodes: Set<number> = new Set();
  selectedNode: TimelineItem | null = null;
  
  // Sample data
  timelineData: TimelineItem[] = [];
  /** Gets the PrimeNG icon class for the status. */
  getStatusIconClass(status: TimelineItem['status']): string {
    switch (status) {
      case 'completed':
        return 'pi pi-check-circle'; // CheckCircle
      case 'working':
        return 'pi pi-spinner pi-spin'; // Activity / Spinner
      case 'pending':
        return 'pi pi-history'; // Clock
      default:
        return 'pi pi-history';
    }
  }

  /** Gets Bootstrap color class for the node background/border (Custom SCSS needed for exact gradients/shadows). */
  getStatusColorClass(status: TimelineItem['status'], userType: TimelineItem['userType']): string {
    // This uses Bootstrap color names for approximation
    if (userType === 'external') {
      switch (status) {
        case 'completed': return 'timeline-node-success'; // Emerald/Green
        case 'working': return 'timeline-node-primary'; // Blue
        case 'pending': return 'timeline-node-secondary'; // Slate/Gray
        default: return 'timeline-node-secondary';
      }
    } else { // internal
      switch (status) {
        case 'completed': return 'timeline-node-purple'; // Violet/Purple
        case 'working': return 'timeline-node-indigo'; // Indigo/Dark Blue
        case 'pending': return 'timeline-node-dark'; // Dark Slate/Gray
        default: return 'timeline-node-dark';
      }
    }
  }

  /** Gets Bootstrap badge color class for status badges. */
  getStatusBadgeColorClass(status: TimelineItem['status']): string {
    switch (status) {
      case 'completed': return 'bg-success-subtle text-success-emphasis border border-success-subtle';
      case 'working': return 'bg-primary-subtle text-primary-emphasis border border-primary-subtle';
      case 'pending': return 'bg-secondary-subtle text-secondary-emphasis border border-secondary-subtle';
      default: return 'bg-secondary-subtle text-secondary-emphasis border border-secondary-subtle';
    }
  }

  /** Gets Bootstrap badge color class for priority badges. */
  getPriorityColorClass(priority: TimelineItem['priority']): string {
    switch (priority) {
      case 'critical': return 'bg-danger text-white';
      case 'high': return 'bg-warning text-dark';
      case 'medium': return 'bg-info text-dark';
      case 'low': return 'bg-success text-white';
      default: return 'bg-secondary text-white';
    }
  }

  /** Gets custom connector SCSS class. */
  getConnectorClass(currentStatus: TimelineItem['status'], index: number, total: number): string {
    if (index === total - 1) return '';
    
    switch (currentStatus) {
      case 'completed': 
        return 'timeline-connector connector-completed';
      case 'working': 
        return 'timeline-connector connector-working';
      default: 
        return 'timeline-connector connector-pending';
    }
  }

  /** Formats the timestamp. */
  formatTimestamp(timestamp: string | null): string {
    if (!timestamp) return 'Pending';
    const date = new Date(timestamp);
    return date.toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric',
      year: '2-digit'
    }) + ' • ' + date.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'});
  }

  /** Toggles the expanded state of an item. */
  toggleExpanded(id: number): void {
    this.expandedItems[id] = !this.expandedItems[id];
  }

handleNodeClick(item: TimelineItem): void {
  this.selectedNode = this.selectedNode?.id === item.id ? null : item;
}

  /** Calculates overall progress percentage. */
  getProgressPercentage(): number {
    const completed = this.timelineData.filter(item => item.status === 'completed').length;
    return Math.round((completed / this.timelineData.length) * 100);
  }
  closeModal(): void {
  this.selectedNode = null;
}

  getworkflowlogs(){
    this.api.getAPI(`/transaction/timeline/?proposal_step=${this.stapName.id}`)
    .subscribe((res: any) => {
      console.log(res)
       this.timelineData = res.data.map((item: any) => ({
        ...item,
        description: `User type: ${item.userType}, Status: ${item.status}`,  // Optional fallback
        priority: this.getPriorityFromRole(item.internalUsers?.[0]?.role),   // You can define this method
      }));
    });
}
getPriorityFromRole(role: string): string {
  if (!role) return '';
  if (role.includes('Edit')) return 'High';
  if (role.includes('Comment')) return 'Medium';
  return 'Low';
}
 routeConfigExpanded: boolean = false;
startIndex = 0;          
windowSize = 3; 
  getTabs() {
    const sub = this.api
      .getAPI(`/master/scheme/${this.schemeId}/phases/`)
      .subscribe((res) => {
        this.tabList = res;
        this.activePhaseId = this.tabList[0].id;
        // this.getProposal();
      });
    this.subscriptions.add(sub);
  }
   onTabChange(event: any): void {
    this.activeTabIndex = event.index;
    this.currentPage = 1;
    this.activePhaseId = this.tabList[event.index]?.id;
    this.selectedPhaseId = this.tabList[event.index]?.id;
    // this.getProposal();
  }
}
interface InternalUser {
  name: string;
  status: 'completed' | 'working' | 'pending';
  timestamp: string | null;
  role: string;
  duration: string | null;
   permission:string;
}
interface TimelineItem {
  id: number;
  name: string;
  userType: 'external' | 'internal';
  status: 'completed' | 'working' | 'pending';
  timestamp: string | null;
  description: string;
  priority: 'critical' | 'high' | 'medium' | 'low';
  duration: string | null;
  hasInternal?: boolean;
  internalUsers?: InternalUser[];
  unit:string
  
}